// Frontend mirror of the backend's EditReason enum at
// libs/domain/src/enums/edit-reason.enum.ts (webapp-back repo).
// Keep aligned — drift here causes BE rejection of FE-submitted reasons.

export enum EditReason {
  WRONG_AMOUNT = 'WRONG_AMOUNT',
  DISCOUNT_GRANTED = 'DISCOUNT_GRANTED',
  WRONG_ITEM = 'WRONG_ITEM',
  EXTEND_VALIDITY = 'EXTEND_VALIDITY',
  REDUCE_QUANTITY = 'REDUCE_QUANTITY',
  OTHER = 'OTHER',
}

export const EDIT_REASON_LABELS_KA: Record<EditReason, string> = {
  [EditReason.WRONG_AMOUNT]: 'არასწორი თანხა',
  [EditReason.DISCOUNT_GRANTED]: 'ფასდაკლება',
  [EditReason.WRONG_ITEM]: 'არასწორი სერვისი',
  [EditReason.EXTEND_VALIDITY]: 'ვადის გაგრძელება',
  [EditReason.REDUCE_QUANTITY]: 'რაოდენობის შემცირება',
  [EditReason.OTHER]: 'სხვა',
};
